import React from 'react' // eslint-disable-line no-unused-vars
import { AbbVieLogo } from '../mi-app/assets/AbbVieLogo'

const Logo = () =>
  <a
    href='https://www.abbvie.com/'
    target='_blank' rel='noopener noreferrer'
    style={{ zIndex: 1040 }}
  >
    <AbbVieLogo/>
  </a>


export default Logo



// WEBPACK FOOTER //
// ./src/elements/Logo.js